import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { RequestInterceptor } from './request.interceptor';
import {PreviewInterceptor} from "./preview.interceptor";

/** Http interceptor providers in outside-in order */
export const httpInterceptorProviders = [
    // { provide: HTTP_INTERCEPTORS, useClass: RequestInterceptor, multi: true },
    {provide: HTTP_INTERCEPTORS, useClass: PreviewInterceptor, multi: true}
];
